import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation, useParams } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import TopNavigation from "./components/TopNavigation";
import ContactListView from "./views/ContactListView";
import TagListView from "./views/TagListView";
import BroadcastView from "./views/BroadcastView";
import AutomationView from "./views/AutomationView";
import { FlowCanvas } from "./views/FlowCanvas";
import "./App.css";
import { SignInPage } from "./setup/signin";
import MyAccountService from "./services/MyAccountService";
import appConfig from "./shared/js/app-config";

// Wrapper to inject routing props into TopNavigation
function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const getActiveTab = () => {
    if (location.pathname.startsWith("/tags")) return "tags";
    if (location.pathname.startsWith("/broadcast")) return "broadcast";
    if (location.pathname.startsWith("/automation")) return "automation";
    if (location.pathname.startsWith("/flow")) return "flow";
    return "contacts";
  };

  const handleTabChange = (tabId) => {
    navigate(`/${tabId}`);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      <TopNavigation
        onMenuClick={() => {}}
        title="WappGrow Dashboard"
        activeTab={getActiveTab()}
        onTabChange={handleTabChange}
      />

      <Box
        sx={{
          // display: "flex",
          // flex: 1,
          mt: "64px",
          // height: "calc(100vh - 64px)",
          width: "100%", height: "100%"
        }}
      >
        <Routes>
          <Route path="/contacts" element={<ContactListView />} />
          <Route path="/tags" element={<TagListView />} />
          <Route path="/broadcast" element={<BroadcastView />} />
          <Route
            path="/automation"
            element={
              <AutomationView
                onNavigateToFlow={(id) => navigate(`/flow/${id}`)}
              />
            }
          />
          <Route
            path="/flow/:automationId"
            element={<FlowCanvasWrapper />}
          />
          <Route
            path="/flow"
            element={<FlowCanvasWrapper />}
          />
          <Route path="*" element={<Navigate to="/contacts" replace />} />
        </Routes>
      </Box>
    </Box>
  );
}

// Wrapper to extract automationId from URL and pass to FlowCanvas
function FlowCanvasWrapper() {
  const id = useParams();
  console.log('idsssssss', id);
  
  return <FlowCanvas automationId={id.automationId} />;
}

// Main App with Router and SignIn logic
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null); // null: loading
  console.log('is', isLoggedIn);
  
  useEffect(() => {
    async function checkLogin() {
      try {
        const account = await MyAccountService.fetch();
        console.log('account', account);
         // should call backend API that reads session
        setIsLoggedIn(!!account?.getId());
      } catch (err) {
        setIsLoggedIn(false);
      }
    }
    checkLogin();
    appConfig.fetch();
  }, []);

  return (
    <Router>
      <Routes>
      
        {isLoggedIn === true ? (
          <Route path="/*" element={<Layout />} />
        ) : (
          <><Route path="*" element={<Navigate to="/signin" replace />} /><Route path="/signin" element={<SignInPage />} /></>
        )}
      </Routes>
    </Router>
  );
}

export default App;
